var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"form__fieldset"},[_c('div',{staticClass:"form__fieldset-header"},[_c('h4',[_vm._t("title")],2)]),_c('div',{staticClass:"form__fieldset-body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }